import { datadogRum } from '@datadog/browser-rum';
import { useAuthContext } from 'providers/auth';
import { FC, useEffect } from 'react';
import { useLocation } from 'react-router';
import { AMPLIFY_KEYS } from 'utils/accounts';
import { buildRumUser, rumRouteIds, setRumCampaign, setRumCompany } from 'utils/datadog-rum';

// Sets ids only; the company and campaign pages add names once their queries load.
export const RumContext: FC = () => {
  const { user, groups, isInternal } = useAuthContext();
  const { pathname } = useLocation();

  useEffect(() => {
    datadogRum.setUser(
      buildRumUser({
        user,
        groups,
        isInternal,
        userPoolId: localStorage.getItem(AMPLIFY_KEYS.userPoolId),
      }),
    );
  }, [user, groups, isInternal]);

  useEffect(() => {
    const { companyId, campaignId } = rumRouteIds(pathname);
    setRumCompany(companyId);
    setRumCampaign(campaignId);
  }, [pathname]);

  useEffect(
    () => () => {
      datadogRum.clearUser();
      setRumCompany(undefined);
      setRumCampaign(undefined);
    },
    [],
  );

  return null;
};
